/* eslint-disable max-len */
import React, {Fragment, Component} from 'react';
import {graphql, compose} from 'react-apollo';
import {autobind} from 'core-decorators';
import {normalize} from 'core/utils';
import userQuery from 'graphql/queries/user.gql';
import faqsQuery from 'graphql/queries/faqs.gql';
import Spinner from 'components/spinner';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import {Input} from 'components/forms';
import styles from './styles.css';

@compose(
    graphql(userQuery, {name: 'userData'}),
    graphql(faqsQuery),
)
@autobind
export default class FAQ extends Component {
    state = {
        query: '',
    };

    handleChange(query) {
        this.setState({query});
    }

    render() {
        if (this.props.data.loading) return <Spinner />;
        const query = normalize(this.state.query);
        const faqsByCategory = this.props.data.faqs
            .filter(({text, answer}) => {
                if (!query) return true;
                return normalize(text).includes(query) || normalize(answer).includes(query);
            })
            .reduce((byCategory, faq) => {
                if (!byCategory[faq.category.name]) byCategory[faq.category.name] = [];
                byCategory[faq.category.name].push(faq);
                return byCategory;
            }, {});

        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='Preguntas frecuentes' />
                <div className={styles.content}>
                    <Input
                        type='text'
                        search
                        value={this.state.query}
                        onChange={this.handleChange}
                        placeholder='Buscar'
                    />
                    {Object.entries(faqsByCategory).map(([category, questions]) => (
                        <Fragment key={category}>
                            <p className={styles.category}>{category}</p>
                            <div className={styles.list}>
                                {questions.map((question, index) => (
                                    <div key={question.id} className={styles.item}>
                                        <p className={styles.question}>{index + 1}. {question.text}</p>
                                        <div className={styles.answer}>
                                            {question.answer
                                                .replace(/\r/gm, '').split('\n')
                                                .filter(line => line !== '')
                                                .map(line => <p key={`${question.id}-${line}`}>{line}</p>)
                                            }
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Fragment>
                    ))}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/faq/index.js